import { flow } from "effect";
import { normalizeParams } from "./normalize";
import { performCalculations } from "./perform-calculations";
import { denormalizeBaseLtv } from "./denormalize";
import { Address } from "@silo/types";
import { CalculateLtvParams, Ltv } from "./types";

export const baseCalculateLtv = flow(
  normalizeParams,
  performCalculations,
  denormalizeBaseLtv
);

export function calculateLtv(params: CalculateLtvParams): Ltv {
  const baseLtv = baseCalculateLtv(params);

  return {
    ...baseLtv,
    args: params,
    depositAssetsMap: createAssetMap(baseLtv.depositAssets),
    debtAssetsMap: createAssetMap(baseLtv.debtAssets),
  };
}

function createAssetMap<T extends { tokenAddress: Address }>(
  assets: T[]
): Map<Address, T> {
  const map: Map<Address, T> = new Map();

  for (const asset of assets) {
    map.set(asset.tokenAddress, asset);
  }

  return map;
}
